import React from 'react';
import { Provider } from 'react-redux';
import store from '@state/store';
import { ConnectShoppingCartButton } from './ConnectShoppingCartButton';

export const ProvideShoppingCartButton = (props: any) => {
  return (
    <Provider store={store}>
      <ConnectShoppingCartButton {...props} />
    </Provider>
  );
};
